import { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface PathwayCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  buttonText: string;
  buttonVariant?: "default" | "outline" | "secondary";
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  badge?: string;
}

export const PathwayCard = ({
  icon: Icon,
  title,
  description,
  buttonText,
  buttonVariant = "default",
  onClick,
  disabled = false,
  loading = false,
  badge,
}: PathwayCardProps) => {
  return (
    <Card className="relative h-full hover:shadow-lg transition-all duration-300 hover:translate-y-[-2px] border-border/50 hover:border-primary/20 group flex flex-col">
      {badge && (
        <div className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-xs font-medium px-2 py-1 rounded-full z-10">
          {badge}
        </div>
      )}
      
      <CardHeader className="text-center pb-4">
        <div className="mx-auto mb-4 p-3 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors">
          <Icon className="h-8 w-8 text-primary" />
        </div>
        <CardTitle className="text-xl mb-2">{title}</CardTitle>
        <CardDescription className="text-base leading-relaxed">
          {description}
        </CardDescription>
      </CardHeader>
      
      <CardContent className="pt-0 flex-1 flex items-end">
        <Button
          onClick={onClick}
          disabled={disabled || loading}
          variant={buttonVariant}
          className="w-full group-hover:scale-105 transition-transform"
          size="lg"
        >
          {loading ? (
            <div className="flex items-center gap-2">
              <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
              Loading...
            </div>
          ) : (
            buttonText
          )}
        </Button>
      </CardContent>
    </Card>
  );
};